import Layout from '@/layout/layout'

const qualityRouter = {
  path: '/quality',
  component: Layout,
  redirect: 'noRedirect',
  name: '成色等级配置',
  children: [
    {
      path: 'levelMatching',
      component: () => import('@/views/quality/levelMatching/index'),
      name: '成色等级配置',
      meta: { title: '成色等级配置', noCache: true }
    },
    {
      path: 'appearanceFunctional',
      component: () => import('@/views/quality/appearanceFunctional/index'),
      name: '外观功能项配置',
      meta: { title: '外观功能项配置', noCache: true }
    },
    {
      path: 'compositionRule',
      component: () => import('@/views/quality/compositionRule/index'),
      name: '成色等级匹配规则',
      meta: { title: '成色等级匹配规则', noCache: true }
    },
    // {
    //   path: 'OutModel',
    //   component: () => import('@/views/quality/OutModel/index'),
    //   name: '外部机型管理',
    //   meta: { title: '外部机型管理', noCache: true }
    // },
  ]
}

export default qualityRouter
